import taskPinComponent from './task-pin.component';

const taskPinModule = angular.module('taskPin', [
])
  .component('taskPin', taskPinComponent)
  .name;

export default taskPinModule;
